module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"tos":"AGB","noInfo":"Bis jetzt keine Informationen."},"en":{"tos":"Terms of Service","noInfo":"No information yet."}}')
  delete Component.options._Ctor
}
